import { ConfigFiltro, Filtro } from "../../filtri.type";
import { OPERATORI } from "../enums/operatori-filtri.enums";

export class FiltriParser {
  configFiltri: ConfigFiltro[] = [];
  filtriRaggruppati: { [key: string]: any } = {};

  backend: { parse(filtriApplicati: Filtro[]): void } = {
    parse: this.backendParse
  };

  private defaultMapper(
    value,
    operator = null,
    fieldname = ""
  ) {
      switch (operator) {
        case 1:
          return value + "%";
        case 2:
          return "%" + value;
        case 3:
          return "%" + value + "%";
        case OPERATORI.NOTLIKE:
          return "%" + value + "%";
        default:
          return value;
      }
    
  }

  private castFiltro(value, filtro: ConfigFiltro) {
    if (!filtro || !filtro.type) {
      return value;
    }
    switch (filtro.type) {
      case "string":
        return String(value);
      case "boolean":
        return "" + value == "0" ? false : true;
      case "number":
        return Number(value);
      default:
        return value;
    }
  }

  private raggruppaFiltri(filtriApplicati: Filtro[]) {
    this.filtriRaggruppati = {};
    for (const filtro of filtriApplicati) {
      if (!Array.isArray(filtro.nomeCampo)) {
        if (!this.filtriRaggruppati[filtro.nomeCampo]) {
          // se non presente la chiave inizializzo
          this.filtriRaggruppati[filtro.nomeCampo] = [
            [filtro.operatoreId, filtro.valore, filtro.idConfig]
          ];
        } else {
          this.filtriRaggruppati[filtro.nomeCampo].push([
            // altrimenti pusho
            filtro.operatoreId,
            filtro.valore,
            filtro.idConfig
          ]);
        }
      } else {
        for (const nomeCampo of filtro.nomeCampo) {
          if (!this.filtriRaggruppati[nomeCampo]) {
            this.filtriRaggruppati[nomeCampo] = [
              [filtro.operatoreId, filtro.valore, filtro.idConfig]
            ];
          } else {
            this.filtriRaggruppati[nomeCampo].push([
              filtro.operatoreId,
              filtro.valore,
              filtro.idConfig
            ]);
          }
        }
      }
    }
    return this.filtriRaggruppati;
  }

  private generaSerieFiltriCampo(
    nomeCampo,
    filtriRaggruppati: any[]
  ) {
    let or = [];
    for (let filtro of filtriRaggruppati) {
      let f = {};
      let config = this.findConfig(
        filtro[2] ? filtro[2] : nomeCampo,
        filtro[2]
      );
      let operatore = this.mapOperatore(filtro[0]);
      let map = this.defaultMapper;
      if (config) {
        if (config.mapTo) {
          map = config.mapTo;
        }
      }
      if (operatore) {
        const value = map(
          this.castFiltro(filtro[1], config),
          filtro[0],
          nomeCampo
        ); //applico mappatura del campo

        const keys = Object.keys(value);
        const operatoreMapped = keys.find(x => ["$gte", "$lte", "$eq", "$in"].indexOf(x) !== -1)
        if (operatoreMapped) {
          f[operatoreMapped] = value[operatoreMapped]
        } else {
          f[operatore] = value;
        }

      } else {
        f = map(this.castFiltro(filtro[1], config), filtro[0], nomeCampo);
      }

      let filtroApplicato = {};
      filtroApplicato[nomeCampo] = f;
      or.push(filtroApplicato);
    }
    return or;
  }

  private generaSerieFiltri(filtriRaggruppati) {
    let and = [];
    // tslint:disable-next-line:forin
    for (let filtro in filtriRaggruppati) {
      const config: ConfigFiltro = this.findConfig(filtro);
      let rule = {};
      let concat = config
        ? config.operatoreConcatenazione
          ? config.operatoreConcatenazione
          : "or"
        : "or";
      rule[concat] = this.generaSerieFiltriCampo(
        filtro,
        filtriRaggruppati[filtro],

      );
      if (filtriRaggruppati[filtro]) {
        and.push(rule);
      }
    }
    return and;
  }

  private generaQuery(filtriRaggruppati) {
    const and = this.generaSerieFiltri(filtriRaggruppati);
    if (and.length > 0) {
      return { and: this.generaSerieFiltri(filtriRaggruppati) };
    } else {
      return {};
    }
  }

  private mapOperatore(codiceOperatore: OPERATORI) {
    switch (codiceOperatore) {
      case OPERATORI.INIZIA_CON:
        return "like";
      case OPERATORI.FINISCE_CON:
        return "like";
      case OPERATORI.CONTIENE:
        return "like";
      case OPERATORI.MAGGIORE:
        return "gt";
      case OPERATORI.MINORE:
        return "lt";
      case OPERATORI.UGUALE:
        return null; //eq funziona solo con le stringhe
      case OPERATORI.MAGGIORE_UGUALE:
        return "gte";
      case OPERATORI.MINORE_UGUALE:
        return "lte";
      case OPERATORI.DIVERSO:
        return "neq";
      case OPERATORI.NOTLIKE:
        return "nlike";
      case OPERATORI.REGEXP:
        return "regexp";
      case OPERATORI.IN:
        return "inq";
      case OPERATORI.UGUALE_DATA:
        return "dateEqual";
      case OPERATORI.MAGGIORE_UGUALE_DATA:
        return "dateGte";
      case OPERATORI.MINORE_UGUALE_DATA:
        return "dateLte";
      case OPERATORI.MAGGIORE_DATA:
        return "dateGt";
      case OPERATORI.MINORE_DATA:
        return "dateLt";
      default:
        return null;
    }
  }

  backendParse(filtriApplicati: Filtro[]) {
    const filtriRaggruppati = this.raggruppaFiltri(filtriApplicati);
    return this.generaQuery(filtriRaggruppati);
  }

  private findConfig(key, useId = false) {
    return this.configFiltri.find(el => {
      if (useId) {
        return el.id == key;
      }
      return el.nomeCampo === key;
    });
  }

  public parse(filtriApplicati: Filtro[]) {
    return this.backendParse(filtriApplicati);
  }
}
